import React from 'react';
import PropTypes from 'prop-types';

import * as Styles from './index.styles';

const { StyledHeader } = Styles;

const DEFAULT_WIDTH = '100%';

export const Header = ({
    width,
    children,
    mobileBreakpoint,
    visibilityOffset,
    hide,
    shadow,
    ...otherProps
}) => {
    const [mobile, setMobile] = React.useState(false);
    const [visible, setVisible] = React.useState(true);

    let prev = window.pageYOffset;

    const handleResize = () => {
        const diff = window.innerWidth - (mobileBreakpoint || 0);
        if (diff <= 0) {
            setMobile(true);
        } else {
            setMobile(false);
        }
    };

    const handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
        if (currentScrollPos === 0) {
            setVisible(true);
        }
        if (currentScrollPos > visibilityOffset) {
            const condition = prev > currentScrollPos;
            setVisible(condition);
            prev = currentScrollPos;
        }
    };

    React.useEffect(() => {
        document.body.style.marginTop = '72px';
        handleResize();
        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
            document.body.style.marginTop = 'initial';
        };
    }, []);

    const childrenArray = React.Children.toArray(children)
        .filter(child => child)
        .map(e => React.cloneElement(e, { mobile }));

    return (
        <StyledHeader
            width={mobile ? DEFAULT_WIDTH : width}
            visible={hide ? visible : true}
            shadow={shadow}
            {...otherProps}
        >
            {childrenArray}
        </StyledHeader>
    );
};

Header.propTypes = {
    width: PropTypes.string,
    children: PropTypes.node.isRequired,
    mobileBreakpoint: PropTypes.number,
    visibilityOffset: PropTypes.number,
    hide: PropTypes.bool,
    shadow: PropTypes.bool,
};

Header.defaultProps = {
    width: DEFAULT_WIDTH,
    mobileBreakpoint: 576,
    visibilityOffset: 72,
    hide: false,
    shadow: false,
};

Header.Styles = Styles;

export * from './HeaderItem';
export * from './HeaderGroup';
